import { GenericModel } from "../../../generic.model";
import { OpeningHoursModel } from "./openingHours.model";
import { makeModel } from "../../../../service/utils/utils.service";
import { NameModel } from "./name.model";
import { TelephoneModel } from "./telephone.model";
import { AddressModel } from "../../common/address/address.model";

export class StationModel extends GenericModel {
    public address: AddressModel;
    public code: string;
    public id: string;
    public keyArray: string[];
    public xId: string;
    public nameArray: NameModel[];
    public openingHoursArray: OpeningHoursModel[];
    public telephoneArray: TelephoneModel[];
    // TODO keywordArray: [{xCode: "Airport", afid: "KW_Airport", index: 1}]

    public get name(): string {
        return this.nameArray[0].value;
    }

    public getOpeningHoursByGroup(group: string): string[] {
        return this.openingHoursArray
            .filter((oH: OpeningHoursModel): boolean => oH.group === group && oH.xStatus === 'Open')
            .map((oH: OpeningHoursModel): string => `${oH.xDayOfWeek}:  ${oH.begin} - ${oH.end}`);
    }

    public getOpeningHoursByGroupSimplified(group: string): string[] {
        const openingHours: string[] = this.getOpeningHoursByGroup(group);
        const res: string[][] = [];
        let i: number = 0;
        openingHours.map((oH: string, index: number): void => {
            const openingHoursSplit: string[] = oH.split(': ');
            if (index === 0) {
                res[i] = [];
                res[i][0] = openingHoursSplit[0];
                res[i][1] = openingHoursSplit[0];
                res[i][2] = openingHoursSplit[1];
            }
            let openingHoursExistIndex: number = null;
            let j: number = 0;
            while (j<=i && openingHoursExistIndex === null) {
                if (openingHoursSplit[1] === res[j][2]) {
                    openingHoursExistIndex = j;
                }
                j++;
            }
            if (openingHoursExistIndex !== null) {
                res[openingHoursExistIndex][1] = openingHoursSplit[0];
            } else {
                i++;
                res[i] = [];
                res[i][0] = openingHoursSplit[0];
                res[i][1] = openingHoursSplit[0];
                res[i][2] = openingHoursSplit[1];
            }
        });
        return res.map((r: string[]): string => r.join(' - '));
    }

    get telephones(): string[] {
        return this.telephoneArray.map((t: TelephoneModel) => `${t.areaPrefix} ${t.number}`);
    }

    protected fromJson(json?: any): boolean {
        this.address = makeModel(json.address, AddressModel);
        this.code = json.code ?? null;
        this.id = json.id ?? null;
        this.keyArray = json.keyArray ?? null;
        this.xId = json.xId ?? null;
        this.nameArray = makeModel(json.nameArray, NameModel);
        this.openingHoursArray = makeModel(json.openingHoursArray, OpeningHoursModel);
        this.telephoneArray = makeModel(json.telephoneArray, TelephoneModel);
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.xId !== null && this.address !== null &&
            this.nameArray !== null && this.nameArray.length > 0 &&
            this.openingHoursArray && this.openingHoursArray.length > 0;
    }
}